import { Button, message, Modal, Tooltip } from "antd";
import { ApiService } from "api/api.service";
import { useState } from "react";
import { TbSearch, TbSparkles } from "react-icons/tb";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { queryClient } from "utils/queryClient";

export default function FCDSLens({
  appKey,
  aiIntelSummary,
}: {
  appKey: string | undefined;
  aiIntelSummary: string | undefined;
}) {
  const getAiIntelSummary = ApiService.application.useGetAiIntelSummary();
  const [isOpen, setIsOpen] = useState(false);
  const data = (aiIntelSummary || getAiIntelSummary?.data?.result?.value)?.replace(/• /g, "- ");

  return (
    <>
      <Tooltip title="FCDS Lens">
        <Button
          variant="solid"
          color="magenta"
          icon={<TbSparkles className="stroke-white fill-white" />}
          loading={getAiIntelSummary.isPending}
          onClick={() => {
            if (aiIntelSummary) {
              setIsOpen(true);
            } else if (appKey) {
              getAiIntelSummary.mutate(appKey, {
                onSuccess: () => {
                  setIsOpen(true);
                  queryClient.invalidateQueries({ queryKey: ["application", appKey] });
                },
              });
            } else {
              return message.error("App key not provided");
            }
          }}
          // className="mesh_bg"
          style={{ background: "transparent", overflow: "hidden" }}
        >
          <div className="mesh_bg" />
          Lens
        </Button>
      </Tooltip>

      <Modal
        title="AI Intel Summary"
        open={isOpen}
        onCancel={() => {
          setIsOpen(false);
        }}
        width={1000}
        height={700}
        footer={null}
      >
        <div className="prose prose-sm max-w-max h-[650px] overflow-auto [&_h1]:text-xl text-justify">
          {/* {getAiIntelSummary?.data?.result?.format === "mardown" ? ( */}
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{data}</ReactMarkdown>
          {/* ) : null} */}
        </div>
      </Modal>
    </>
  );
}
